import { Base } from '../base-component';
import './infographic-page-noblurb.component.scss';

export class InfographicPageNoblurb extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/infographic-page-noblurb/infographic-page-noblurb.component.ts